module.exports = __webpack_public_path__ + "c2a0388c8134a1fa5cc3d6f9cdac15ab.svg";